import { post } from './request';

export async function email(pl) {
	const res = await post(`${process.env.REACT_APP_API}api/general/email`, pl);
	return res.result;
}